module.exports = __webpack_public_path__ + "img/program_development.65a7e802.jpg";